import { buildModelManager } from "../builder.js";
const DefaultStripeChargeSelection = {
  __typename: true,
  id: true,
  amountFee: true,
  amountGross: true,
  amountNet: true,
  chargeCreatedAt: true,
  chargeId: true,
  createdAt: true,
  currency: true,
  disputeId: true,
  disputeReason: true,
  failureCode: true,
  failureMessage: true,
  invoiceId: true,
  paymentIntentId: true,
  payoutId: true,
  profileId: true,
  refundedAmount: true,
  status: true,
  updatedAt: true,
  workItemId: true
};
const modelApiIdentifier = "stripeCharge";
const pluralModelApiIdentifier = "stripeCharges";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultStripeChargeSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultStripeChargeSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultStripeChargeSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultStripeChargeSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultStripeChargeSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultStripeChargeSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultStripeChargeSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByChargeId",
    findByField: "chargeId",
    findByVariableName: "chargeId",
    modelApiIdentifier,
    defaultSelection: DefaultStripeChargeSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByChargeId",
    findByField: "chargeId",
    findByVariableName: "chargeId",
    modelApiIdentifier,
    defaultSelection: DefaultStripeChargeSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "stripeChargeGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const StripeChargeManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultStripeChargeSelection,
  operations
);
export {
  DefaultStripeChargeSelection,
  StripeChargeManager
};
//# sourceMappingURL=StripeCharge.js.map
